<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="12" view-id="10012" approve-type="4" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="12" :data="data">
					<!--状态-->
					<template #status>
						<c-state dict="flowOrderStateDic" :value="data.status"></c-state>
					</template>

					<!--紧急程度-->
					<template #emergency_level>
						<c-state dict="orderUrgencyDic" :value="data.emergency_level"></c-state>
					</template>

					<!--请假类型-->
					<template #leave_type>
						<c-state dict="leaveTypeDic" :value="data.leave_type"></c-state>
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_leave_application',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/affairs/leave/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>